import { pushToDataLayer } from '@skeleton/utils/dataLayer';

export const usePlug2Win = () => {
  if (!import.meta.client) return;

  const profileStore = useProfileStore();
  const { isLoggedIn, profile } = storeToRefs(profileStore);

  const walletStore = useWalletStore();
  const { activeAccount } = storeToRefs(walletStore);

  const globalStore = useGlobalStore();
  const { headerCountry, currentLocale } = storeToRefs(globalStore);

  const currency = computed(() => activeAccount.value?.currency);

  const getPlug2WinData = () => {
    if (!profile.value) return null;

    return {
      userId: profile.value.id,
      geo: headerCountry.value || profile.value.country,
      currency: currency.value,
      locale: profile.value.locale || currentLocale.value?.code,
    };
  };

  const pushPlug2WinEvent = (eventName: string) => {
    const data = getPlug2WinData();
    if (!data) return;

    window.plug2win = data;
    pushToDataLayer(eventName, data);
  };

  const initPlug2Win = () => {
    if (!isLoggedIn.value || !profile.value || typeof window === 'undefined') return;
    pushPlug2WinEvent('plug2winReady');
  };

  const clearPlug2Win = () => {
    if (typeof window === 'undefined') return;

    delete window.plug2win;

    pushToDataLayer('plug2winCleared');
    localStorage.removeItem('PLAYED_GAMES_IDS_LS_KEY');
  };

  watch(
    isLoggedIn,
    loggedIn => {
      if (loggedIn) {
        initPlug2Win();
      } else {
        clearPlug2Win();
      }
    },
    { immediate: true }
  );

  watch(currency, () => {
    if (!isLoggedIn.value || !window.plug2win) return;
    pushPlug2WinEvent('plug2winChanged');
  });
};
